/* istanbul ignore next */
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export const ENV = {
  API_DOMAIN: '',
};

export const logger: Logger & { init: boolean } = {
  init: false,
  log: noop,
  error: noop,
};

export type SetupApiProps = {
  env: typeof ENV | { [key: string]: string | undefined };
  logger?: Logger;
};

/**
 * This function must be called at initialization before using
 * any functions from `@findigs/api`
 */
export function setupApi({ env, logger: _logger }: SetupApiProps) {
  let key: keyof typeof ENV;
  for (key in ENV) {
    const value = key in env ? env[key] : undefined;
    if (value !== undefined) {
      ENV[key] = value;
    }
  }

  Object.assign(logger, _logger, { init: Boolean(_logger) });
}
